'use client'

import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  List,
} from '@mui/material'
import { CSSProperties } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { helper } from 'helper'

import { Icons } from './variables'

interface MenuItemProps {
  text: string
  nav: string // ex: '/security'
  icon: JSX.Element
  selectedStyle: (path: string) => CSSProperties
}

const MenuItem = (props: MenuItemProps) => {
  const navigate = useNavigate()

  const handleNavigation = (path: string) => {
    return () => navigate(path)
  }

  return (
    <ListItem
      disablePadding
      onClick={handleNavigation(props.nav)}
      sx={props.selectedStyle(props.nav)}
    >
      <ListItemButton>
        <ListItemIcon>{props.icon}</ListItemIcon>
        <ListItemText
          primary={props.text}
          primaryTypographyProps={menuTextTypographyStyle}
        />
      </ListItemButton>
    </ListItem>
  )
}

export default function MenuListComponent() {
  const location = useLocation()
  const pathname = location.pathname

  const selectedStyle = (path: string): CSSProperties => {
    const isMatch = new RegExp(`^${path}/?$`).test(pathname)
    if (isMatch) {
      return {
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
      }
    } else {
      return {}
    }
  }

  // TODO メニューの一覧を整備する
  // 現状、2号向けくもかんからコピーしてそのままのため、不要なメニューがある
  return (
    <List>
      <MenuItem
        text={'警備先'}
        nav={'/security_field'}
        icon={<Icons.securityField />}
        selectedStyle={selectedStyle}
      />
      <MenuItem
        text={'隊員'}
        nav={'/security'}
        icon={<Icons.security />}
        selectedStyle={selectedStyle}
      />
      {helper.env.isDev && (
        // DEBUG用
        <MenuItem
          text={'debug'}
          nav={'/shift/list'}
          icon={<Icons.answerOk />}
          selectedStyle={selectedStyle}
        />
      )}
    </List>
  )
}

const menuTextTypographyStyle = {
  style: {
    fontSize: '14px',
  },
}
